import { connect } from "react-redux"
import Component from "../../components/SurveySelect/Secondary"
import { getField } from "../../store/dataexport.selectors"

const mapState = state => ({
  surveyType: getField(state, "surveyType")
})

export default connect(mapState)(Component)
